export const TOGGLE_LOADING = 'transfer/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'transfer/TOGGLE_SUCCESS'
export const SET_CONTRACTS = 'transfer/SET_CONTRACTS'
export const RESET_CONTRACTS = 'transfer/RESET_CONTRACTS'
